<div
  [ngClass]="{
    'select-typeahead--expanded': expanded,
    'select-typeahead--searching': searching && enabled,
  }"
  appFormControl
  class="select-typeahead"
>
  <select
    [attr.required]="required"
    [attr.tabindex]="-1"
    [formControl]="control"
    [id]="id"
    [name]="name"
    class="select-typeahead__input"
  >
    @for (option of optionsList; track $index) {
      <option [value]="option.value">{{ option.label }}</option>
    }
  </select>

  <label [htmlFor]="searchElementId" class="select-typeahead__search-label">
    Search
  </label>

  <div class="select-typeahead__search-input-container">
    <ng-container
      [ngTemplateOutlet]="searchInputFocused ? searchInput : displayInput"
    />

    @if (valueString && enabled && !searching) {
      <button
        (click)="clearInputValue()"
        [attr.aria-label]="'clear'"
        [disabled]="disabled"
        class="select-typeahead__clear"
        type="button"
      >
        <app-icon [name]="'close'" class="select-typeahead__clear-icon" />
      </button>
    }
  </div>

  <app-form-select-dropdown
    (collapsed)="collapse()"
    (selected)="onSelection($event)"
    [disabled]="disabled || searching"
    [expanded]="expanded"
    [noResultsLabel]="noResultsLabel()"
    [optionSubLabels]="optionSubLabels()"
    [optionTemplate]="optionTemplate"
    [options]="optionsList"
    [searchTerm]="searchTerm"
    [selectedValue]="valueString"
  />
  <app-validity-icon [valid]="control.valid" />
</div>

<ng-template #searchInput>
  <input
    #searchInputElement
    (blur)="onSearchInputBlur()"
    (input)="searchInputElementChange()"
    [disabled]="disabled"
    [id]="searchElementId"
    [name]="name"
    [placeholder]="placeholder() ?? ''"
    [value]="searchTerm"
    autocomplete="off"
    class="select-typeahead__search-input"
    dgxFormRestrictedCharacters
    type="search"
  />

  @if (enabled && searching) {
    <app-form-loading-spinner class="select-typeahead__loading" />
  }
</ng-template>

<ng-template #displayInput>
  <input
    (focus)="onDisplayInputFocus()"
    [disabled]="disabled"
    [id]="searchElementId"
    [name]="name"
    [placeholder]="placeholder() ?? ''"
    [value]="selectedOption?.label"
    autocomplete="off"
    class="select-typeahead__search-input select-typeahead__search-input--display"
    readonly="true"
    type="search"
  />
</ng-template>
